<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.data"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.data"
                            end-label="Até"
                            range
                            start-label="Data de"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!model.data.start && !model.data.end"
                            :validations="validations.hora.start"
                            @input="handleHoraStartInput"
                            label="Hora de"
                            v-model="model.hora.start"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :disabled="!model.data.start && !model.data.end"
                            :validations="validations.hora.end"
                            @input="handleHoraEndInput"
                            label="Até"
                            v-model="model.hora.end"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Usuário"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.status"
                            @change="handleStatusChange"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.statusId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                    hide-filters
                />
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Totais"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalAcessos"
                            disabled
                            label="Total de acessos"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalAcessoRealizadoComSucesso"
                            disabled
                            label="Total de acessos realizados com sucesso"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalUsuarioEOuSenhaIncorretos"
                            disabled
                            label="Total de usuário e/ou senha incorretos"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalUsuarioBloqueado"
                            disabled
                            label="Total de usuários bloqueados"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalUsuarioAcesso"
                            disabled
                            label="Total de usuários que acessaram o sistema"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                data: {required: true},
                hora: {
                    start: {
                        max_hour: this.model.hora.end ? this.formatTime(this.model.hora.end) : null,
                    },
                    end: {
                        min_hour: this.model.hora.start ? this.formatTime(this.model.hora.start) : null,
                    },
                },
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.administracao'),
            impressao: this.getConectaSusRepository('impressao.administracao'),
            relatorioAcessoSistema: this.getConectaSusRepository('administracao.relatorioAcessoSistema'),
        }

        this.load()
    },
    data() {
        return {
            additionals: null,
            form: null,
            data: null,
            fields: [
                {formatter: value => this.formatDate(value), key: 'data', label: 'Data', sortable: true},
                {key: 'hora', label: 'Hora', sortable: true},
                {key: 'usuarioNome', label: 'Usuário', sortable: true},
                {key: 'statusNome', label: 'Status', sortable: true},
            ],
            model: null,
            others: {moment},
            sortBy: 'data',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioAcessoSistema.create()
                .then((response) => {
                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
            }

            this.setLoading()

            this.repositories.relatorioAcessoSistema.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.usuarios = []
            this.form.status = []

            this.model.data = {
                start: null,
                end: null,
            }

            this.model.hora = {
                start: null,
                end: null,
            }

            this.model.usuarioId = null
            this.model.statusId = null
            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioAcessoSistema(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                },
                usuarioId: this.model.usuarioId,
                statusId: this.model.statusId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioAcessoSistema(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleHoraStartInput(value) {
            this.form.usuarios = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.statusId = null
            this.data = null

            const request = {
                listar: 'usuarios',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: value,
                    end: this.model.hora.end,
                },
            }

            this.setLoading()

            this.repositories.relatorioAcessoSistema.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleHoraEndInput(value) {
            this.form.usuarios = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.statusId = null
            this.data = null

            const request = {
                listar: 'usuarios',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: value,
                },
            }

            this.setLoading()

            this.repositories.relatorioAcessoSistema.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.status = []
            this.model.statusId = null
            this.data = null

            const request = {
                listar: 'status',
                data: {
                    start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                },
                hora: {
                    start: this.model.hora.start,
                    end: this.model.hora.end,
                    usuarioId: value,
                },
            }

            this.setLoading()

            this.repositories.relatorioAcessoSistema.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.status = Object.assign(response.data.status))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleStatusChange() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, formats, repository, stringCase],
    watch: {
        'model.data': {
            deep: true,
            handler(value) {
                this.form.usuarios = []
                this.form.status = []

                this.model.hora = {
                    start: null,
                    end: null,
                }

                this.model.usuarioId = null
                this.model.statusId = null
                this.data = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'usuarios',
                    data: {
                        start: this.others.moment(this.model.data.start).format('DD/MM/YYYY'),
                        end: this.others.moment(this.model.data.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioAcessoSistema.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.status = Object.assign(response.data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>